class StoreSwitcherNewCountryForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setCountryAttributes()
    this.setNewsletterCountry()
    this.emailCheck()
    this.setComingSoonCountryCode()
    this.setComingSoonCountryName()
    this.setCopyCountryPlaceholder()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)
    this.emailCheck = this.emailCheck.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
    this.listeners.add(this.els.email.element, 'input', this.emailCheck)
    this.listeners.add(this.els.email.element, 'change', this.emailCheck)
  }

  emailCheck () {
    const emailValue = this.els.email.element.value

    if (emailValue && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      this.els.submit.element.disabled = false
    } else {
      this.els.submit.element.disabled = true
    }
  }

  setComingSoonCountryCode () {
    if (!this.els?.comingSoonCountryCode?.exists) return

    this.els.comingSoonCountryCode.element.value = this.comingSoonCountryCode
  }

  setCountryAttributes () {
    if (this.comingSoonCountryCode) {
      this.setAttribute('country', this.comingSoonCountryCode)
    }

    if (this.comingSoonCountryName) {
      this.dataset.country = this.comingSoonCountryName
      this.dataset.countryname = this.comingSoonCountryName
      this.setAttribute('countryname', this.comingSoonCountryName)
    }
  }

  setNewsletterCountry () {
    if (!this.els?.country?.exists) return
    if (!this.comingSoonCountryName) return

    this.els.country.element.value = this.comingSoonCountryName
  }

  setComingSoonCountryName () {
    if (!this.els?.comingSoonCountryName?.exists) return

    this.els.comingSoonCountryName.element.value = this.comingSoonCountryName
  }

  setCopyCountryPlaceholder () {
    if (!this.els?.copy?.exists) return
    if (!this.comingSoonCountryName) return

    const copyHtml = this.els.copy.element.innerHTML
    if (!copyHtml.includes('[country]')) return

    this.els.copy.element.innerHTML = copyHtml.replace(
      /\[country\]/gi,
      this.escapeHtml(this.comingSoonCountryName),
    )
  }

  escapeHtml (value = '') {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  async handleSubmit (event) {
    event.preventDefault()

    const customerEmail = this.els.email?.element?.value
    if (!customerEmail) return

    const countryCode = window.localStorage.getItem('PP-BAO-localization')
    const latestStorefront = window.theme.latestStorefront

    let listId = this.listId

    const customerCountry = this.dataset?.country || null
    if (customerCountry) {
      switch (customerCountry) {
        case 'Germany':
          listId = 'SF5ivA'
          break
        case 'South Korea':
          listId = 'TvmRXw'
          break
      }
    }

    try {
      const profileAttributes = {
        email: customerEmail,
        subscriptions: {
          email: {
            marketing: {
              consent: 'SUBSCRIBED',
            },
          },
        },
      }

      const properties = {}
      const comingSoonCountryCode =
        this.els.comingSoonCountryCode.element.value
      const comingSoonCountryName =
        this.els.comingSoonCountryName.element.value

      if (countryCode) {
        properties.CountryCode = countryCode
      }

      if (latestStorefront) {
        properties['Latest StoreName'] = latestStorefront
      }

      if (comingSoonCountryCode) {
        properties.comingSoonCountryCode = comingSoonCountryCode
      }

      if (comingSoonCountryName) {
        properties.comingSoonCountryName = comingSoonCountryName
      }

      if (Object.keys(properties).length) {
        profileAttributes.properties = properties
      }

      const subscriptionAttributes = {
        profile: {
          data: {
            type: 'profile',
            attributes: profileAttributes,
          },
        },
      }

      if (customerCountry) {
        subscriptionAttributes.profile.data.attributes.location = {
          country: customerCountry,
        }
      }

      if (this.customSource) {
        subscriptionAttributes.custom_source = this.customSource
      }

      const bodyData = {
        data: {
          type: 'subscription',
          attributes: subscriptionAttributes,
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: window.theme.klaviyo.apiVersion,
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(bodyData),
      }

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`)
      }

      this.els.form.element.setAttribute('aria-hidden', true)
      this.els.submitted.element.setAttribute('aria-hidden', false)

      window.BAO.dispatchEvent(window.BAO.EVENTS.KLAVIYO.FORM_SUBMITTED, {
        customerEmail,
      })
    } catch (error) {
      console.error('Store switcher new country subscription error:', error)
    }
  }

  get comingSoonCountryCode () {
    // eslint-disable-next-line compat/compat
    const urlCountryCode = new URLSearchParams(window.location.search).get(
      'setComingSoonCountryCode',
    )

    return urlCountryCode || this.dataset.comingSoonCountryCode || ''
  }

  get comingSoonCountryName () {
    // eslint-disable-next-line compat/compat
    const urlCountryName = new URLSearchParams(window.location.search).get(
      'setComingSoonCountryName',
    )

    return urlCountryName || this.dataset.comingSoonCountryName || ''
  }

  get listId () {
    return this.dataset.listId || window.theme.klaviyo.newsletterListId
  }

  get customSource () {
    return this.dataset.customSource || null
  }
}

if (!customElements.get('store-switcher-new-country-form')) {
  customElements.define(
    'store-switcher-new-country-form',
    StoreSwitcherNewCountryForm,
  )
}
